module.exports = __webpack_public_path__ + "static/media/TK.18169e46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/TK.svg
// module id = 2275
// module chunks = 7